module.exports = __webpack_public_path__ + "static/media/about.4ec48b40.jpg";